import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Alert } from './Alert';

const StyledAlert = styled(Alert)`
  text-align: center;
  background: unset !important;
  border: unset !important;
  shadow: unset !important;
`;

export const AlertHome = (): JSX.Element => {
  return (
    <StyledAlert
      variant="error"
      round="none"
      pad="small"
      className="alert error"
    >
      <FormattedMessage defaultMessage="Tip: Endurance has adopted the Ethereum network protocol, in order to ensure that the technical updates are consistent with Ethereum, the staking page content follows the Ethereum launchpad page." />
    </StyledAlert>
  );
};
